import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/projects/Admin_Bite_Balance/bite-balance/src/components/ui/button";
import { Input } from "@/projects/Admin_Bite_Balance/bite-balance/src/components/ui/input";
import { Label } from "@/projects/Admin_Bite_Balance/bite-balance/src/components/ui/label";
import { Activity } from "lucide-react";
import welcomeBg from "@/projects/Admin_Bite_Balance/bite-balance/src/assets/welcome-bg.jpg";

const Login = () => {
  const navigate = useNavigate();
  const [isSignup, setIsSignup] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // For now, just navigate to onboarding
    // In production, this would authenticate with backend
    navigate("/onboarding");
  };

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden p-6">
      {/* Blurred Background Image */}
      <div
        className="absolute inset-0 scale-105 bg-cover bg-center bg-no-repeat blur-sm"
        style={{ backgroundImage: `url(${welcomeBg})` }}
      />

      {/* Overlay for better text readability */}
      <div className="absolute inset-0 bg-black/50" />

      <div className="relative z-10 w-full max-w-md space-y-8">
        {/* Logo */}
        <div className="flex flex-col items-center gap-4">
          <div className="bg-gradient-primary flex h-20 w-20 items-center justify-center rounded-[2rem] shadow-primary">
            <Activity className="h-10 w-10 text-primary-foreground" />
          </div>
          <h1 className="text-4xl font-bold text-white drop-shadow-lg">
            Bite Balance
          </h1>
        </div>

        {/* Form */}
        <div className="space-y-6 rounded-3xl border border-border/50 bg-card/50 p-6 backdrop-blur-sm">
          <div className="text-center">
            <h2 className="mb-2 text-2xl font-bold text-foreground">
              {isSignup ? "Create Account" : "Welcome Back"}
            </h2>
            <p className="text-muted-foreground">
              {isSignup
                ? "Start your health journey today"
                : "Sign in to continue"}
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="email" className="text-foreground">
                Email
              </Label>
              <Input
                id="email"
                type="email"
                placeholder="you@example.com"
                value={formData.email}
                onChange={e =>
                  setFormData({ ...formData, email: e.target.value })
                }
                className="mt-2"
                required
              />
            </div>

            <div>
              <Label htmlFor="password" className="text-foreground">
                Password
              </Label>
              <Input
                id="password"
                type="password"
                placeholder="••••••••"
                value={formData.password}
                onChange={e =>
                  setFormData({ ...formData, password: e.target.value })
                }
                className="mt-2"
                required
              />
            </div>

            {isSignup && (
              <div>
                <Label htmlFor="confirmPassword" className="text-foreground">
                  Confirm Password
                </Label>
                <Input
                  id="confirmPassword"
                  type="password"
                  placeholder="••••••••"
                  value={formData.confirmPassword}
                  onChange={e =>
                    setFormData({
                      ...formData,
                      confirmPassword: e.target.value,
                    })
                  }
                  className="mt-2"
                  required
                />
              </div>
            )}

            <Button
              type="submit"
              className="bg-gradient-primary h-12 w-full rounded-2xl text-base shadow-primary hover:opacity-90"
            >
              {isSignup ? "Sign Up" : "Sign In"}
            </Button>
          </form>

          <div className="text-center">
            <button
              onClick={() => setIsSignup(!isSignup)}
              className="text-sm text-primary hover:underline"
            >
              {isSignup
                ? "Already have an account? Sign In"
                : "Don't have an account? Sign Up"}
            </button>
          </div>
        </div>

        <p className="text-center text-xs font-medium text-white">
          By continuing, you agree to our Terms of Service and Privacy Policy
        </p>
      </div>
    </div>
  );
};

export default Login;
